<template>
<div class="content">
  <el-row>
    <el-col :span="5">
      <div class="grid-content"></div>
    </el-col>
    <el-col :span="14" style="border-bottom:1px solid #E1E5E8; line-height:35px">
      <div class="grid-content"><span><i class="el-icon-user"></i><strong>{{userInfo.studentName||userInfo.username}}</strong></span>
        <el-button type="text" @click="logout">（退出登录）</el-button>
      </div>

    </el-col>


  </el-row>
  <el-row style="padding-top:15px">
    <el-col :span="3">
      <div class="grid-content"></div>
    </el-col>
    <el-col :span="3" class="search">
      <div style="padding-top:4px;">
        <el-input v-model="searchForm.title" size="mini" placeholder="按标题"></el-input>
      </div>
      <div style="padding-top:4px;">
        <el-select v-model="searchForm.type" size="mini" style="width: 100%">
          <el-option v-for="item in type" :value="item.id" :label="item.name" :key="item.id">{{item.name}}</el-option>
        </el-select>
      </div>
      <div style="padding-top:2px;">
        <el-date-picker v-model="searchDate" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="dateChange" size="mini" style="width:100%">
        </el-date-picker>
      </div>
      <div class="grid-content" style="padding-top:4px;">
        <!-- <el-tree ref="serviceItemTree" v-model="searchForm.serviceItem" :props="props1" :load="loadServiceItem" lazy show-checkbox node-key="id"></el-tree> -->

        <el-cascader ref="serviceItemTree" :props="servicesProps" size="mini" style="width:100%" placeholder="按服务"></el-cascader>
      </div>
      <div style="padding-top:4px;"><el-button type="success" size="mini" @click="search">查询</el-button></div>
    </el-col>

    <el-col :span="15" style="padding-left:2px; ">

      <el-table :data="tableData" stripe style="width: 100%; min-height:570px; border-radius:2px" @row-click="openDetails">
        <el-table-column label="分类" width="200">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.tieziType=='1'" type="danger">投诉-{{scope.row.serviceItemName}}-{{scope.row.serviceItemIdName}}</el-tag>
            <el-tag v-if="scope.row.tieziType=='2'" type="warning">建议-{{scope.row.serviceItemName}}-{{scope.row.serviceItemIdName}}</el-tag>
            <el-tag v-if="scope.row.tieziType=='3'" type="warning">咨询-{{scope.row.serviceItemName}}-{{scope.row.serviceItemIdName}}</el-tag>
            <el-tag v-if="scope.row.tieziType=='4'" type="warning">表扬-{{scope.row.serviceItemName}}-{{scope.row.serviceItemIdName}}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="title" label="标题">
        </el-table-column>
        <el-table-column prop="userName" label="发帖人">
        </el-table-column>
        <!-- <el-table-column prop="replyPerson" label="回复人" width="100">
        </el-table-column> -->



        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.replyCount>0" type="success">已回复</el-tag>
            <el-tag v-if="scope.row.replyCount==0" type="info">未回复</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="createDate" label="发布时间">
        </el-table-column>

      </el-table>
    </el-col>
  </el-row>

  <el-row style="text-align:center; padding-top:10px">
    <el-pagination background layout="prev, pager, next" :total="total" :page-size="searchForm.size" @current-change="handleCurrentChange" :current-page.sync="searchForm.page"></el-pagination>
  </el-row>


</div>
</template>

<script>
let id = 0;
import { getServiceItemByPid,getMyPostList,getPostList,OK,HOST,pclogin,casHost} from '../../api/data.js'
export default {
  name: 'ComplaintsAndSuggestionsForm',
  data() {
    let _this = this
    //自定义验证器校验手机号码
    var checkPhone = (rule, value, callback) => {
      const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
      if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error('手机号格式错误'))
      }
    };
    return {
      tableData: [],
      userInfo: {},
      casAuthorization: '',
      ruleForm: {
        username: '', //用户名
        password: '' //密码
      },
      rules: {
        username: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }, ],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }, ]
      },
      fullscreenLoading: false,
      searchForm: {
        title: '',
        type: 0,
        status: '',
        date: '',
        author: '',
        serviceItem: '',
        page: 1,
        size: 10
      },
      props1: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf'
      },
      type: [],
      searchDate: [],
      total: 1,
      servicesProps: {
        multiple: true,
        label: 'name',
        value: 'id',
        leaf: 'leaf',
        lazy: true,
        lazyLoad(node, resolve) {
          const {
            level
          } = node;
          if (node.level === 0) {
            getServiceItemByPid(id).then((res) => {
              resolve(res.data.data)
            }).catch(function(res) {
              console.log(res);
            })

          }

          if (node.level > 0) {

            getServiceItemByPid(node.data.id).then((res) => {
              resolve(res.data.data)
            }).catch(function(res) {
              console.log(res);
            })

          }
        }
      }
    };
  },
  methods: {
    handleCurrentChange() {
      this.getMyPostList()
    },
    dateFormat() {
      this.searchForm.date = this.searchDate + ''

    },
    getCheckedNodes() {
      this.searchForm.serviceItem = ''
      let items = this.$refs.serviceItemTree.getCheckedNodes()

      //console.log(items);
      for (let item in items) {
        // console.log();
        // var nodeId = items[item].data.id
        if (this.searchForm.serviceItem != '')
          this.searchForm.serviceItem += ","
        this.searchForm.serviceItem = this.searchForm.serviceItem + items[item].data.id
      }
    },
    search() {
      this.getCheckedNodes()
      this.dateFormat()
      this.searchForm.page = 1
      this.getMyPostList()
    },
    dateChange(val) {
      this.searchForm.date = val;
    },
    submitForm(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          let _this = this
          pclogin( this.ruleForm.username,this.ruleForm.password).then(function(res){
            // console.log(res.data)
          if (res.data.success===true) {
              localStorage.setItem("casUser", JSON.stringify(res.data))
              _this.$router.push("/")
            } else {
              alert(res.data.data)
            }
          }).catch(function(res) {
            console.log(res);
          })
          setTimeout(() => {
            loading.close();
          }, 200);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    logout() {
    /*  let ticket = decodeURIComponent((new RegExp('[?|&]' +  'ticket' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
      const host = window.location.hostname
      const protocol = window.location.protocol
      const port =    window.location.port
      let service = protocol + "//" + host;
      if ("80"!==port|| "443"!==port) {//默认端口，不加在跳转路径下
        service += ":" + port+"/#/stuCasLogin";
      }else {
        service +="/#/stuCasLogin";
      }*/
/*      if(ticket){
        let redirect = casHost + "login?service=" + service;
        //console.log(' redirect:'+redirect)
        window.location.href = redirect

      }else {
        localStorage.removeItem('casUser')
        location.reload()
      }*/
      let ticket = decodeURIComponent((new RegExp('[?|&]' +  'ticket' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
      if(ticket){

        localStorage.removeItem('casUser')
      }else {
        localStorage.removeItem('casUser')
        window.location.href = '/#/pc'
      }


/*      this.$router.push({
        path: '/pc'
      })*/

    },
    getMyPostList() {
      let _this = this
      getMyPostList(this.searchForm.title,this.searchForm.type,this.searchForm.status,this.searchForm.date,this.searchForm.author,this.searchForm.serviceItem,this.searchForm.page,this.searchForm.size, _this.casAuthorization).then(function(res) {
        if(res.data.flag == 'failure'){
          //console.log(res.data);
          if(res.data.data == '201'){
            _this.$alert('登录超时，请重新登录', {
              confirmButtonText: '确定'
            }).then(()=>{
              _this.$router.push('/PCLogin')
            })
          }else if (res.data.data == '202'){
            _this.$alert('还未登录', {
              confirmButtonText: '确定'
            }).then(()=>{
              _this.$router.push('/PCLogin')
            })
          }
        }else{
          _this.tableData = res.data.data.list
          _this.total = res.data.data.total
          // console.log(res.data.data);
        }

      }).catch(function(res) {
        console.log(res);
      })
    },
    loadServiceItem(node, resolve) {
      let _this = this
      if (node.level === 0) {


        getServiceItemByPid(0).then((res) => {
          resolve(res.data.data)
        }).catch(function(res) {
          console.log(res);
        })

      } else {
        // console.log(node);


        getServiceItemByPid(node.data.id).then((res) => {
          resolve(res.data.data)
        }).catch(function(res) {
          console.log(res);
        })

      }
    },
    openDetails(row) {
      this.$router.push({path:'casMyDetail', query:{detailId:row.id}})
    }
  },
  mounted() {
    let data = JSON.parse(localStorage.getItem("casUser"));
    // console.log(data);
    if (data) {
      let token = data.data.token

      this.userInfo = data.data
      this.casAuthorization = token
      // console.log(this.userInfo);

      this.getMyPostList()

      let type_json = this.common.getType();
      this.type = JSON.parse(type_json);
    } else {
      //未登录，跳转到登录页面
      this.$router.push('/PCLogin')
    }
  }

}
</script>


<style scoped>
.form_border {
  border: 1px solid grey;
  padding: 5px;
  border-radius: 10px;
}

.content {

}
.search{
  height: 570px;
  background: white;
  border-radius: 5px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/mine.vue